import React, {useState} from 'react';
import FieldProto from "../../../../proto/field-proto";
import FieldVoting from "../../voting";
import {ALL_REACTIONS} from "../../../../../model2/reaction/const";

type Props = {
    className?  : string
    field       : FieldVoting
    onClick     : callback      // open dropdown
    children    : any
}

export default function FieldVoting_InlineValueEmpty(props:Props) {

    const [isHovered, setIsHovered] = useState(false)

    const onMouseEnter = () => {
        if (!isHovered) setIsHovered(true)
    }

    const onMouseLeave = () => {
        if (isHovered) setIsHovered(false)
    }

    if (isHovered) {
        return (
            <React.Fragment>
                <div className={Classes("ui5-field-editable is-hovered size-default", props.className)}
                     onClick={props.onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>

                    <div className="flex-row-left-center">
                        <div className="ui5-emoji ui5-black-and-white m-r-8">
                            {ALL_REACTIONS[props.field.voteIcon]}
                        </div>

                        <div className="ui5-txt-no-accent-small">0</div>
                    </div>

                </div>
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <div className={Classes("ui5-field-editable size-default", props.className)}
                 onClick={props.onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>

            </div>
            {props.children}
        </React.Fragment>
    )

}
